import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Input = (props) => (
  <div className="input_group">
    <input
      className="input_item"
      onChange={props.onChange}
      value={props.value}
      type={props.type}
      maxLength={props.maxLength}
      placeholder={props.placeholder}
      max={props.max}
      min={props.min}
      name={props.name}
      pattern={props.pattern}
      required={props.required}
      disabled={props.disabled}
      autoComplete={props.autocomplete}
    />
    <span className="input_label">{props.label}</span>
  </div>
);
Input.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  pattern: PropTypes.instanceOf(RegExp),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  autocomplete: PropTypes.string,
  value: PropTypes.string,
};
Input.defaultProps = {
  label: '',
  type: null,
  maxLength: 256,
  onChange: () => {},
  placeholder: ' ',
  max: null,
  min: null,
  name: null,
  pattern: null,
  required: false,
  disabled: false,
  autocomplete: 'off',
  value: '',
};

export default Input;
